<template>
  <a
    href="javascript:;"
    class="text-hover text-blue text-[14px] font-medium leading-[16px] flex items-center gap-x-[8px]"
    @click="handleClick"
  >
    <InlineSvg
      v-if="preIcon"
      :src="`/assets/svg/icons/${preIcon}.svg`"
      :class="iconClasses"
    />
    {{ text }}
    <InlineSvg
      v-if="icon"
      :src="`/assets/svg/icons/${icon}.svg`"
      :class="iconClasses"
    />
  </a>
</template>

<script setup>
import { useRouter } from 'vue-router';
const router = useRouter();
const emit = defineEmits(['clicked']);
const props = defineProps({
  text: {
    type: String,
    default: '',
  },
  preIcon: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
  iconClasses: {
    type: String,
    default: '',
  },
  route: {
    type: Object,
    default: null,
  },
});

const handleClick = () => {
  if (props.route) return router.push(props.route);
  emit('clicked');
};
</script>

<style lang="scss" scoped></style>
